import React from "react";
import { Link } from "gatsby";

const FabricAndSafetyLink = () => (
    <p>Read the <Link to="/safety-information">safety and quality guidelines</Link> and see <Link to="/fabric-suppliers">fabric suppliers</Link>.</p>
);

export default FabricAndSafetyLink;